<template>
	<div class="resume">
		<el-container>
			<el-header class="personalheader">
				<div class="nidrlogo">
					<img src="../../image/zsdb_logo.png" />
				</div>
				<div class="accoutInfo">
					<span class="headerText">尊敬的用户{{showId}}，您好！</span>
					<span class="divider">|</span>
					<el-link type="primary" class="headerText" @click="gotohome()">招聘首页</el-link>
					<span class="divider">|</span>
					<el-link type="primary" @click="exit()" class="headerText">退出</el-link>
				</div>
			</el-header>
			<el-container>
				<el-aside class="personalaside">
					<el-menu default-active="1" class="personalmenu" background-color="#545c64" text-color="#fff"
						active-text-color="#ffd04b">
						<el-menu-item index="1" @click="gotoresume()">
							<span class="menuText" slot="title">个人简历</span>
						</el-menu-item>
						<el-menu-item index="2" @click="gotocollect()">
							<span class="menuText" slot="title">已收藏岗位</span>
						</el-menu-item>
						<el-menu-item index="3" @click="gotosubmit()">
							<span class="menuText" slot="title">我的投递</span>
						</el-menu-item>
					</el-menu>
				</el-aside>
				<el-main class="personalbody">
					<div class="resumeContainer">
						<el-form :label-position="labelPosition" :model="ruleForm" :rules="rules" ref="ruleForm"
							label-width="175px" class="ruleForm">
							<el-divider content-position="left">基础信息</el-divider>
							<el-form-item label="简历类型:" prop="resumestate">
								<el-radio-group v-model="ruleForm.resumestate">
									<el-radio :label="0">校园招聘</el-radio>
									<el-radio :label="1">社会招聘</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="姓名:" prop="name" class="ruleFormitem">
								<el-input placeholder="请输入姓名" v-model="ruleForm.name"></el-input>
							</el-form-item>
							<el-form-item label="性别:" prop="sex">
								<el-radio-group v-model="ruleForm.sex">
									<el-radio label="男"></el-radio>
									<el-radio label="女"></el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="出生日期:" required>
								<el-form-item prop="birthdate" style="width: 100%;">
									<el-date-picker v-model="ruleForm.birthdate" align="right" type="date"
										placeholder="选择出生日期" :picker-options="pickerOptions" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd">
									</el-date-picker>
								</el-form-item>
							</el-form-item>
							<el-form-item label="年龄:" prop="age" class="ruleFormitem">
								<el-input placeholder="请输入年龄" v-model="ruleForm.age"></el-input>
							</el-form-item>
							<el-form-item label="身高:" prop="height" class="ruleFormitem">
								<el-input placeholder="请输入身高" v-model="ruleForm.height" class="height"></el-input>
								<span>cm</span>
							</el-form-item>
							<el-form-item label="体重:" prop="weight" class="ruleFormitem">
								<el-input placeholder="请输入体重" v-model="ruleForm.weight" class="height"></el-input>
								<span>kg</span>
							</el-form-item>
							<el-form-item label="邮箱:" prop="email" class="ruleFormitem">
								<el-input placeholder="请输入邮箱" v-model="ruleForm.email"></el-input>
							</el-form-item>
							<el-form-item label="手机号码:" prop="phonenumber" class="ruleFormitem">
								<el-input placeholder="请输入手机号" v-model="ruleForm.phonenumber"></el-input>
							</el-form-item>
							<el-form-item label="证件类型:" prop="documenttype">
								<el-select v-model="ruleForm.documenttype" placeholder="请选择证件类型" style="width: 100%;">
									<el-option v-for="item in documenttypeoptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="证件号码:" prop="documentnumber" class="ruleFormitem">
								<el-input placeholder="请输入证件号码" v-model="ruleForm.documentnumber"></el-input>
							</el-form-item>
							<el-form-item label="最高学历:" prop="education">
								<el-select v-model="ruleForm.education" placeholder="请选择最高学历" style="width: 100%;">
									<el-option v-for="item in educationoptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="学习形式:" prop="degreemode">
								<el-select v-model="ruleForm.degreemode" placeholder="请选择学习方式" style="width: 100%;">
									<el-option v-for="item in degreemodeoptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="毕业时间:" required>
								<el-form-item prop="graduatedate" style="width: 100%;">
									<el-date-picker v-model="ruleForm.graduatedate" align="right" type="date"
										placeholder="选择毕业日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
									</el-date-picker>
								</el-form-item>
							</el-form-item>
							<!-- <el-form-item label="海外留学经历:" prop="studyabroad">
								<el-radio-group v-model="ruleForm.studyabroad">
									<el-radio :label="0">是</el-radio>
									<el-radio :label="1">否</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="应届/往届:" prop="freshgraduates">
								<el-radio-group v-model="ruleForm.freshgraduates">
									<el-radio :label="0">应届</el-radio>
									<el-radio :label="1">往届</el-radio>
								</el-radio-group>
							</el-form-item> -->
							<!-- <el-form-item label="工作年限（如无工作经历此项无需填写）:" prop="workinghours">
								<el-select v-model="ruleForm.workinghours" placeholder="请选择工作年限" style="width: 100%;">
									<el-option v-for="item in workinghoursoptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="参加工作时间:">
								<el-col>
									<el-form-item prop="workingdate" style="width: 100%;">
										<el-date-picker v-model="ruleForm.workingdate" align="right" type="date"
											placeholder="选择参加工作时间" :picker-options="pickerOptions" format="yyyy-MM-dd"
											value-format="yyyy-MM-dd">
										</el-date-picker>
									</el-form-item>
								</el-col>
							</el-form-item> -->
							<el-form-item label="现居住地:" prop="nowresidence" class="ruleFormitem">
								<el-input placeholder="请填写XX省XX市" v-model="ruleForm.nowresidence"></el-input>
							</el-form-item>
							<el-form-item label="政治面貌:" prop="political">
								<el-select v-model="ruleForm.political" placeholder="请选择政治面貌" style="width: 100%;">
									<el-option v-for="item in politicaloptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="民族:" prop="nation" required>
								<el-select v-model="ruleForm.nation" placeholder="请选择民族" style="width: 100%;">
									<el-option v-for="item in nationoptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="籍贯:" prop="nativeplace" class="ruleFormitem">
								<el-input placeholder="请填写XX省XX市" v-model="ruleForm.nativeplace"></el-input>
							</el-form-item>
							<el-form-item label="婚姻状态:" prop="maritalstatus">
								<el-select v-model="ruleForm.maritalstatus" placeholder="请选择婚姻状况" style="width: 100%;">
									<el-option v-for="item in maritalstatusoptions" :key="item.value"
										:label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<!-- <el-form-item label="有无子女:" prop="childstatus">
								<el-radio-group v-model="ruleForm.childstatus">
									<el-radio label="有">有</el-radio>
									<el-radio label="无">无</el-radio>
								</el-radio-group>
							</el-form-item> -->
							<el-form-item label="紧急联系人联系方式:" prop="emergencycontactphonenumber" class="ruleFormitem">
								<el-input placeholder="请输入紧急联系人联系方式" v-model="ruleForm.emergencycontactphonenumber">
								</el-input>
							</el-form-item>
							<el-form-item label="英语等级:" prop="englishlevel">
								<el-select v-model="ruleForm.englishlevel" placeholder="请选择英语等级" style="width: 100%;">
									<el-option v-for="item in englishleveloptions" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="英语等级成绩:" prop="englishlevelscore" class="ruleFormitem">
								<el-input placeholder="请输入英语等级成绩" v-model="ruleForm.englishlevelscore">
								</el-input>
							</el-form-item>
							<el-divider content-position="left"><span class="mustText"> * </span>教育经历</el-divider>
							<div class="educational_experience">
								<div class="explanatory"><span
										style="color: darkgray; font-size: 14px;">*注：请如实填写您所有的教育经历(从最高学历填写至初中),保证信息的完整性,</span><br />
									<span style="color: darkgray; font-size: 14px;">若没有专业相关信息请在对应位置填写"无"</span>
								</div>
								<div v-for="(item,index) in educationalBackground" class="Descriptions">
									<el-descriptions :key="index" :educationalBackground="item"
										v-if="educationalBackground.length > 0" direction="vertical" :column="4" border>
										<el-descriptions-item label="学校名称">{{item.name}}</el-descriptions-item>
										<el-descriptions-item label="起止时间">{{item.startTime}} 至 {{item.endTime}}
										</el-descriptions-item>
										<el-descriptions-item label="专业名称">{{item.majorName}}</el-descriptions-item>
										<el-descriptions-item label="学历">{{item.degree}}</el-descriptions-item>
										<el-descriptions-item label="专业排名">{{item.professionalRanking}}
										</el-descriptions-item>
										<el-descriptions-item label="专业课程">{{item.professionalCourses}}
										</el-descriptions-item>
									</el-descriptions>
									<el-button type="text" @click="dialogDelete('educationalBackground' ,index)"
										class="dialogDelete">
										删除
									</el-button>
								</div>
								<el-button type="text" @click="dialogeducationalbackground = true" class="Increase">
									+立即添加
								</el-button>
							</div>

							<el-dialog title="教育经历" :visible.sync="dialogeducationalbackground">
								<el-form :model="educationalbackgroundruleForm" :label-position="labelPosition"
									ref="educationalbackgroundruleForm" label-width="125px" class="DialogruleForm">
									<el-form-item label="学校名称:" class="DialogruleFormitem">
										<el-input placeholder="请输入学校名称"
											v-model="educationalbackgroundruleForm.schoolname">
										</el-input>
									</el-form-item>
									<el-form-item label="起止时间:">
										<el-col>
											<el-form-item style="width: 100%;">
												<el-date-picker v-model="educationalbackgroundruleForm.studytime"
													align="right" type="daterange" range-separator="至"
													start-placeholder="开始日期" end-placeholder="结束日期" placeholder="选择就读时间"
													format="yyyy-MM-dd" value-format="yyyy-MM-dd">
												</el-date-picker>
											</el-form-item>
										</el-col>
									</el-form-item>
									<el-form-item label="专业名称:" class="DialogruleFormitem">
										<el-input placeholder="请输入专业名称"
											v-model="educationalbackgroundruleForm.majorname">
										</el-input>
									</el-form-item>
									<el-form-item label="学历:">
										<el-select v-model="educationalbackgroundruleForm.dialogeducation"
											placeholder="请选择学历" style="width: 100%;">
											<el-option v-for="item in educationoptions1" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="专业课程:" class="DialogruleFormitem">
										<el-input placeholder="请输入专业课程"
											v-model="educationalbackgroundruleForm.majorcourses" type="textarea"
											:autosize="{ minRows: 2}">
										</el-input>
									</el-form-item>
									<el-form-item label="专业排名:">
										<el-select v-model="educationalbackgroundruleForm.majorranking"
											placeholder="请选择学历" style="width: 100%;">
											<el-option v-for="item in majorrankingoptions" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogeducationalbackground = false">取 消</el-button>
									<el-button type="primary" @click="addeducationalbackground()">确 定</el-button>
								</div>
							</el-dialog>


							<el-divider content-position="left">实习经历</el-divider>
							<div v-for="(item,index) in internshipExperience" class="Descriptions">
								<el-descriptions :key="item.companyName" :internshipExperience="item"
									v-if="internshipExperience.length > 0" direction="vertical" border>
									<el-descriptions-item label="公司">{{item.companyName}}</el-descriptions-item>
									<el-descriptions-item label="职位">{{item.position}}</el-descriptions-item>
									<el-descriptions-item label="起止时间">{{item.startTime}} 至 {{item.endTime}}
									</el-descriptions-item>
									<el-descriptions-item label="实习内容描述">{{item.content}}</el-descriptions-item>
								</el-descriptions>
								<el-button type="text" @click="dialogDelete('internshipExperience' ,index)"
									class="dialogDelete">
									删除
								</el-button>
							</div>

							<el-button type="text" @click="dialoginternshipExperience = true" class="Increase">+立即添加
							</el-button>
							<el-dialog title="实习经历" :visible.sync="dialoginternshipExperience">
								<el-form :model="internshipExperienceruleForm" :label-position="labelPosition"
									ref="internshipExperienceruleForm" label-width="125px" class="DialogruleForm">
									<el-form-item label="公司:" class="DialogruleFormitem">
										<el-input placeholder="请输入公司名称"
											v-model="internshipExperienceruleForm.internshipExperiencename">
										</el-input>
									</el-form-item>
									<el-form-item label="职位:" class="DialogruleFormitem">
										<el-input placeholder="请输入职位名称" v-model="internshipExperienceruleForm.position">
										</el-input>
									</el-form-item>
									<el-form-item label="起止时间:">
										<el-col>
											<el-form-item style="width: 100%;">
												<el-date-picker
													v-model="internshipExperienceruleForm.internshipExperiencetime"
													align="right" type="daterange" range-separator="至"
													start-placeholder="开始日期" end-placeholder="结束日期" placeholder="选择就读时间"
													:picker-options="pickerOptions" format="yyyy-MM-dd"
													value-format="yyyy-MM-dd">
												</el-date-picker>
											</el-form-item>
										</el-col>
									</el-form-item>
									<el-form-item label="实习内容描述:" class="DialogruleFormitem">
										<el-input placeholder="请输入实习内容描述"
											v-model="internshipExperienceruleForm.internshipExperiencecontent"
											type="textarea" :autosize="{ minRows: 2}">
										</el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialoginternshipExperience = false">取 消</el-button>
									<el-button type="primary" @click="addinternshipExperience()">确 定</el-button>
								</div>
							</el-dialog>


							<el-divider content-position="left">工作经历</el-divider>
							<div v-for="(item,index) in workExperience" :key="item.companyName" class="Descriptions">
								<el-descriptions :workExperience="item" v-if="workExperience.length > 0"
									direction="vertical" border>
									<el-descriptions-item label="公司">{{item.companyName}}</el-descriptions-item>
									<el-descriptions-item label="职位">{{item.position}}</el-descriptions-item>
									<el-descriptions-item label="起止时间">{{item.startTime}} 至 {{item.endTime}}
									</el-descriptions-item>
									<el-descriptions-item label="工作内容描述">{{item.content}}</el-descriptions-item>
								</el-descriptions>
								<el-button type="text" @click="dialogDelete('workExperience' ,index)"
									class="dialogDelete">
									删除
								</el-button>
							</div>
							<el-button type="text" @click="dialogworkExperience = true" class="Increase">+立即添加
							</el-button>

							<el-dialog title="工作经历" :visible.sync="dialogworkExperience">
								<el-form :model="workExperienceruleForm" :label-position="labelPosition"
									ref="workExperienceruleForm" label-width="125px" class="DialogruleForm">
									<el-form-item label="公司:" class="DialogruleFormitem">
										<el-input placeholder="请输入公司名称"
											v-model="workExperienceruleForm.workExperiencename">
										</el-input>
									</el-form-item>
									<el-form-item label="职位:" class="DialogruleFormitem">
										<el-input placeholder="请输入职位名称" v-model="workExperienceruleForm.position">
										</el-input>
									</el-form-item>
									<el-form-item label="起止时间:">
										<el-col>
											<el-form-item style="width: 100%;">
												<el-date-picker v-model="workExperienceruleForm.workExperiencetime"
													align="right" type="daterange" range-separator="至"
													start-placeholder="开始日期" end-placeholder="结束日期" placeholder="选择就读时间"
													:picker-options="pickerOptions" format="yyyy-MM-dd"
													value-format="yyyy-MM-dd">
												</el-date-picker>
											</el-form-item>
										</el-col>
									</el-form-item>
									<el-form-item label="工作内容描述:" class="DialogruleFormitem">
										<el-input placeholder="请输入工作内容"
											v-model="workExperienceruleForm.workExperiencecontent" type="textarea"
											:autosize="{ minRows: 2}">
										</el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogworkExperience = false">取 消</el-button>
									<el-button type="primary" @click="addworkExperience()">确 定</el-button>
								</div>
							</el-dialog>


							<el-divider content-position="left">项目经历</el-divider>
							<div v-for="(item,index) in projectExperience" class="Descriptions" :key="item.projectName">
								<el-descriptions :projectExperience="item" v-if="projectExperience.length > 0"
									direction="vertical" border>
									<el-descriptions-item label="项目名称">{{item.projectName}}</el-descriptions-item>
									<el-descriptions-item label="项目角色">{{item.position}}</el-descriptions-item>
									<el-descriptions-item label="起止时间">{{item.startTime}} 至 {{item.endTime}}
									</el-descriptions-item>
									<el-descriptions-item label="项目描述">{{item.description}}</el-descriptions-item>
								</el-descriptions>
								<el-button type="text" @click="dialogDelete('projectExperience' ,index)"
									class="dialogDelete">
									删除
								</el-button>
							</div>
							<el-button type="text" @click="dialogprojectExperience = true" class="Increase">+立即添加
							</el-button>

							<el-dialog title="项目经历" :visible.sync="dialogprojectExperience">
								<el-form :model="projectExperienceruleForm" :label-position="labelPosition"
									ref="projectExperienceruleForm" label-width="125px" class="DialogruleForm">
									<el-form-item label="项目名称:" class="DialogruleFormitem">
										<el-input placeholder="请输入项目名称" v-model="projectExperienceruleForm.projectName">
										</el-input>
									</el-form-item>
									<el-form-item label="项目角色:" class="DialogruleFormitem">
										<el-input placeholder="请输入项目角色" v-model="projectExperienceruleForm.position">
										</el-input>
									</el-form-item>
									<el-form-item label="起止时间:">
										<el-col>
											<el-form-item style="width: 100%;">
												<el-date-picker
													v-model="projectExperienceruleForm.projectExperiencetime"
													align="right" type="daterange" range-separator="至"
													start-placeholder="开始日期" end-placeholder="结束日期" placeholder="选择就读时间"
													:picker-options="pickerOptions" format="yyyy-MM-dd"
													value-format="yyyy-MM-dd">
												</el-date-picker>
											</el-form-item>
										</el-col>
									</el-form-item>
									<el-form-item label="项目描述:" class="DialogruleFormitem">
										<el-input placeholder="请输入项目描述" v-model="projectExperienceruleForm.description"
											type="textarea" :autosize="{ minRows: 2}">
										</el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogprojectExperience = false">取 消</el-button>
									<el-button type="primary" @click="addprojectExperience()">确 定</el-button>
								</div>
							</el-dialog>


							<el-divider content-position="left">获奖情况</el-divider>
							<div v-for="(item,index) in awards" class="Descriptions" :key="item.awardType">
								<el-descriptions :awards="item" v-if="awards.length > 0" direction="vertical" border>
									<el-descriptions-item label="奖项类型">{{item.awardType}}</el-descriptions-item>
									<el-descriptions-item label="奖项名称">{{item.name}}</el-descriptions-item>
									<el-descriptions-item label="获奖时间">{{item.time}}</el-descriptions-item>
									<el-descriptions-item label="奖项描述">{{item.description}}</el-descriptions-item>
								</el-descriptions>
								<el-button type="text" @click="dialogDelete('awards' ,index)" class="dialogDelete">
									删除
								</el-button>
							</div>
							<el-button type="text" @click="dialogawards = true" class="Increase">+立即添加
							</el-button>

							<el-dialog title="获奖情况" :visible.sync="dialogawards">
								<el-form :model="awardsruleForm" :label-position="labelPosition" ref="awardsruleForm"
									label-width="125px" class="DialogruleForm">
									<el-form-item label="奖项类型:">
										<el-select v-model="awardsruleForm.awardType" placeholder="请选择奖项类型"
											style="width: 100%;">
											<el-option v-for="item in awardTypeoptions" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="奖项名称:" class="DialogruleFormitem">
										<el-input placeholder="请输入奖项名称" v-model="awardsruleForm.awardsname">
										</el-input>
									</el-form-item>
									<el-form-item label="获奖时间:">
										<el-col>
											<el-form-item style="width: 100%;">
												<el-date-picker v-model="awardsruleForm.awardstime" align="right"
													type="date" :picker-options="pickerOptions" format="yyyy-MM-dd"
													value-format="yyyy-MM-dd">
												</el-date-picker>
											</el-form-item>
										</el-col>
									</el-form-item>
									<el-form-item label="奖项描述:" class="DialogruleFormitem">
										<el-input placeholder="请输入奖项描述" v-model="awardsruleForm.description"
											type="textarea" :autosize="{ minRows: 2}">
										</el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogawards = false">取 消</el-button>
									<el-button type="primary" @click="addawards()">确 定</el-button>
								</div>
							</el-dialog>


							<el-divider content-position="left">论文著作情况</el-divider>
							<div v-for="(item,index) in papersMonographs" :key="item.name" class="Descriptions">
								<el-descriptions :papersMonographs="item" v-if="papersMonographs.length > 0"
									direction="vertical" border>
									<el-descriptions-item label="名称">{{item.name}}</el-descriptions-item>
									<el-descriptions-item label="发布时间">{{item.time}}</el-descriptions-item>
									<el-descriptions-item label="发表期刊">{{item.periodical}}</el-descriptions-item>
									<el-descriptions-item label="作者顺序">{{item.authorOrder}}</el-descriptions-item>
									<el-descriptions-item label="论文著作描述">{{item.annualPeriod}}</el-descriptions-item>
								</el-descriptions>
								<el-button type="text" @click="dialogDelete('papersMonographs' ,index)"
									class="dialogDelete">
									删除
								</el-button>
							</div>
							<el-button type="text" @click="dialogpapersMonographs = true" class="Increase">+立即添加
							</el-button>

							<el-dialog title="论文著作情况" :visible.sync="dialogpapersMonographs">
								<el-form :model="papersMonographsruleForm" :label-position="labelPosition"
									ref="papersMonographsruleForm" label-width="125px" class="DialogruleForm">
									<el-form-item label="名称:" class="DialogruleFormitem">
										<el-input placeholder="请输入名称"
											v-model="papersMonographsruleForm.papersMonographsname">
										</el-input>
									</el-form-item>
									<el-form-item label="发布时间:">
										<el-col>
											<el-form-item style="width: 100%;">
												<el-date-picker v-model="papersMonographsruleForm.papersMonographstime"
													align="right" type="date" :picker-options="pickerOptions"
													format="yyyy-MM-dd" value-format="yyyy-MM-dd">
												</el-date-picker>
											</el-form-item>
										</el-col>
									</el-form-item>
									<el-form-item label="发表期刊:" class="DialogruleFormitem">
										<el-input placeholder="如类型为论文，请填写所属期刊名称；如类型为著作，此处请填写“无”。"
											v-model="papersMonographsruleForm.papersMonographsperiodical">
										</el-input>
									</el-form-item>
									<el-form-item label="作者顺序:" class="DialogruleFormitem">
										<el-input placeholder="请输入作者顺序"
											v-model="papersMonographsruleForm.papersMonographsauthorOrder">
										</el-input>
									</el-form-item>
									<el-form-item label="论文著作描述:" class="DialogruleFormitem">
										<el-input placeholder="请输入论文著作描述" type="textarea" :autosize="{ minRows: 2}"
											v-model="papersMonographsruleForm.papersMonographsannualPeriod">
										</el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogpapersMonographs = false">取 消</el-button>
									<el-button type="primary" @click="addpapersMonographs()">确 定</el-button>
								</div>
							</el-dialog>


							<el-divider content-position="left">资格证书</el-divider>
							<div v-for="(item,index) in certificate" :key="item.type" class="Descriptions">
								<el-descriptions :certificate="item" v-if="certificate.length > 0" direction="vertical"
									border>
									<el-descriptions-item label="证书种类">{{item.type}}</el-descriptions-item>
									<el-descriptions-item label="证书名称">{{item.name}}</el-descriptions-item>
									<el-descriptions-item label="获得时间">{{item.time}}</el-descriptions-item>
									<el-descriptions-item label="证书描述">{{item.description}}</el-descriptions-item>
								</el-descriptions>
								<el-button type="text" @click="dialogDelete('certificate' ,index)" class="dialogDelete">
									删除
								</el-button>
							</div>
							<el-button type="text" @click="dialogcertificate = true" class="Increase">+立即添加
							</el-button>

							<el-dialog title="资格证书" :visible.sync="dialogcertificate">
								<el-form :model="certificateruleForm" :label-position="labelPosition"
									ref="certificateruleForm" label-width="125px" class="DialogruleForm">
									<el-form-item label="证书种类:" class="DialogruleFormitem">
										<el-input placeholder="请输入证书类型" v-model="certificateruleForm.type">
										</el-input>
									</el-form-item>
									<el-form-item label="证书名称:" class="DialogruleFormitem">
										<el-input placeholder="请输入证书名称" v-model="certificateruleForm.name">
										</el-input>
									</el-form-item>
									<el-form-item label="获得时间:">
										<el-col>
											<el-form-item style="width: 100%;">
												<el-date-picker v-model="certificateruleForm.time" align="right"
													type="date" :picker-options="pickerOptions" format="yyyy-MM-dd"
													value-format="yyyy-MM-dd">
												</el-date-picker>
											</el-form-item>
										</el-col>
									</el-form-item>
									<el-form-item label="证书描述:" class="DialogruleFormitem">
										<el-input placeholder="请输入证书描述" v-model="certificateruleForm.description"
											type="textarea" :autosize="{ minRows: 2}">
										</el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogcertificate = false">取 消</el-button>
									<el-button type="primary" @click="addcertificate()">确 定</el-button>
								</div>
							</el-dialog>


							<el-divider content-position="left">语言能力</el-divider>
							<div v-for="(item,index) in languageSkills" :key="item.languageType" class="Descriptions">
								<el-descriptions :languageSkills="item" v-if="languageSkills.length > 0"
									direction="vertical" border>
									<el-descriptions-item label="语言">{{item.languageType}}</el-descriptions-item>
									<el-descriptions-item label="精通程度">{{item.mastery}}</el-descriptions-item>
								</el-descriptions>
								<el-button type="text" @click="dialogDelete('languageSkills' ,index)"
									class="dialogDelete">
									删除
								</el-button>
							</div>
							<el-button type="text" @click="dialoglanguageSkills = true" class="Increase">+立即添加
							</el-button>

							<el-dialog title="语言能力" :visible.sync="dialoglanguageSkills">
								<el-form :model="languageSkillsruleForm" :label-position="labelPosition"
									ref="languageSkillsruleForm" label-width="125px" class="DialogruleForm">
									<el-form-item label="语言:" class="DialogruleFormitem">
										<el-select v-model="languageSkillsruleForm.languageType" placeholder="请输入精通程度"
											style="width: 100%;">
											<el-option v-for="item in languageTypeselect" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item label="精通程度:">
										<el-select v-model="languageSkillsruleForm.mastery" placeholder="请选择精通程度"
											style="width: 100%;">
											<el-option v-for="item in masteryselect" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialoglanguageSkills = false">取 消</el-button>
									<el-button type="primary" @click="addlanguageSkill()">确 定</el-button>
								</div>
							</el-dialog>


							<el-divider content-position="left">技能</el-divider>
							<div v-for="(item,index2) in skills" :key="item.name" class="Descriptions">
								<el-descriptions :skills="item" v-if="skills.length > 0" direction="vertical" border>
									<el-descriptions-item label="技能名称">{{item.name}}</el-descriptions-item>
									<el-descriptions-item label="掌握程度">{{item.mastery}}</el-descriptions-item>
								</el-descriptions>
								<el-button type="text" @click="dialogDelete('skills' ,index2)" class="dialogDelete">
									删除
								</el-button>
							</div>
							<el-button type="text" @click="dialogskills = true" class="Increase">+立即添加
							</el-button>

							<el-dialog title="技能" :visible.sync="dialogskills">
								<el-form :model="skillsruleForm" :label-position="labelPosition" ref="skillsruleForm"
									label-width="125px" class="DialogruleForm">
									<el-form-item label="技能名称:" class="DialogruleFormitem">
										<el-input placeholder="请输入技能名称" v-model="skillsruleForm.name">
										</el-input>
									</el-form-item>
									<el-form-item label="掌握程度:">
										<el-select v-model="skillsruleForm.skillsMastery" placeholder="请选择学历"
											style="width: 100%;">
											<el-option v-for="item in skillsMasterySelect" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogskills = false">取 消</el-button>
									<el-button type="primary" @click="addskills()">确 定</el-button>
								</div>
							</el-dialog>

							<el-divider content-position="left">亲属在水利系统从业情况（如无此类情况则无需填写）
							</el-divider>
							<div class="Descriptions" v-for="(item,index1) in closeRelative" :key="item.name">
								<el-divider>亲属情况{{index1+1}}</el-divider>
								<el-button type="text" @click="dialogRelative(index1)" class="dialogDelete">
									删除
								</el-button>
								<div class="relatives_form">
									<el-form ref="relativeForm" :model="item" label-width="200px"
										class="relative_form_item">
										<el-form-item label="姓名:" class="DialogruleFormitem">
											<el-input placeholder="请输入姓名" v-model="item.name">
											</el-input>
										</el-form-item>
										<el-form-item label="与本人关系:" class="DialogruleFormitem">
											<el-input placeholder="请输入与本人关系" v-model="item.relationship">
											</el-input>
										</el-form-item>
										<el-form-item label="工作单位:" class="DialogruleFormitem">
											<el-input placeholder="请输入工作单位" v-model="item.companyName">
											</el-input>
										</el-form-item>
										<el-form-item label="职务:" class="DialogruleFormitem">
											<el-input placeholder="请输入职务" v-model="item.position">
											</el-input>
										</el-form-item>
										<el-form-item label="联系电话:" class="DialogruleFormitem">
											<el-input placeholder="请输入联系电话" v-model="item.phoneNumber">
											</el-input>
										</el-form-item>
									</el-form>
								</div>
							</div>
							<el-button type="text" @click="addRelatives()" class="Increase">+添加亲属情况
							</el-button>

							<!-- <el-divider content-position="left">亲属在水利系统从业情况（如无此类情况则无需填写）
							</el-divider>
							<div v-for="(item,index1) in closeRelative" :key="item.name" class="Descriptions">
								<el-descriptions :familySituation="item" v-if="closeRelative.length > 0"
									direction="vertical" border>
									<el-descriptions-item label="姓名">{{item.name}}</el-descriptions-item>
									<el-descriptions-item label="与本人关系">{{item.relationship}}</el-descriptions-item>
									<el-descriptions-item label="工作单位">{{item.companyName}}</el-descriptions-item>
									<el-descriptions-item label="职务">{{item.position}}</el-descriptions-item>
									<el-descriptions-item label="联系电话">{{item.phoneNumber}}</el-descriptions-item>
								</el-descriptions>
								<el-button type="text" @click="dialogDelete('closeRelative' ,index1)"
									class="dialogDelete">
									删除
								</el-button>
							</div>

							<el-button type="text" @click="dialogcloseRelative = true" class="Increase">+添加亲属情况
							</el-button>


							<el-dialog title="亲属情况" :visible.sync="dialogcloseRelative">
								<el-form :model="familySituationruleForm" :label-position="labelPosition"
									ref="familySituationruleForm" label-width="125px" class="DialogruleForm">
									<el-form-item label="姓名:" class="DialogruleFormitem">
										<el-input placeholder="请输入姓名" v-model="closeRelativeruleForm.name">
										</el-input>
									</el-form-item>
									<el-form-item label="与本人关系:" class="DialogruleFormitem">
										<el-input placeholder="请输入与本人关系" v-model="closeRelativeruleForm.relationship">
										</el-input>
									</el-form-item>
									<el-form-item label="工作单位:" class="DialogruleFormitem">
										<el-input placeholder="请输入工作单位" v-model="closeRelativeruleForm.companyName">
										</el-input>
									</el-form-item>
									<el-form-item label="职务:" class="DialogruleFormitem">
										<el-input placeholder="请输入职务" v-model="closeRelativeruleForm.position">
										</el-input>
									</el-form-item>
									<el-form-item label="联系电话:" class="DialogruleFormitem">
										<el-input placeholder="请输入联系电话" v-model="closeRelativeruleForm.phoneNumber">
										</el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogcloseRelative = false">取 消</el-button>
									<el-button type="primary" @click="addcloseRelative()">确 定</el-button>
								</div>
							</el-dialog> -->

							<el-divider content-position="left"><span class="mustText"> * </span>家庭主要成员情况
							</el-divider>
							<div v-for="(item,index1) in familySituation" :key="item.name" class="Descriptions">
								<el-descriptions :familySituation="item" v-if="familySituation.length > 0"
									direction="vertical" border>
									<el-descriptions-item label="姓名">{{item.name}}</el-descriptions-item>
									<el-descriptions-item label="与本人关系">{{item.relationship}}</el-descriptions-item>
									<el-descriptions-item label="工作单位">{{item.companyName}}</el-descriptions-item>
									<el-descriptions-item label="职务">{{item.position}}</el-descriptions-item>
									<el-descriptions-item label="联系电话">{{item.phoneNumber}}</el-descriptions-item>
								</el-descriptions>
								<el-button type="text" @click="dialogDelete('familySituation' ,index1)"
									class="dialogDelete">
									删除
								</el-button>
							</div>
							<el-button type="text" @click="dialogfamilySituation = true" class="Increase">+立即添加
							</el-button>

							<el-dialog title="家庭主要成员情况" :visible.sync="dialogfamilySituation">
								<el-form :model="familySituationruleForm" :label-position="labelPosition"
									ref="familySituationruleForm" label-width="125px" class="DialogruleForm">
									<el-form-item label="姓名:" class="DialogruleFormitem">
										<el-input placeholder="请输入姓名" v-model="familySituationruleForm.name">
										</el-input>
									</el-form-item>
									<el-form-item label="与本人关系:" class="DialogruleFormitem">
										<el-input placeholder="请输入与本人关系" v-model="familySituationruleForm.relationship">
										</el-input>
									</el-form-item>
									<el-form-item label="工作单位:" class="DialogruleFormitem">
										<el-input placeholder="请输入工作单位" v-model="familySituationruleForm.companyName">
										</el-input>
									</el-form-item>
									<el-form-item label="职务:" class="DialogruleFormitem">
										<el-input placeholder="请输入职务" v-model="familySituationruleForm.position">
										</el-input>
									</el-form-item>
									<el-form-item label="联系电话:" class="DialogruleFormitem">
										<el-input placeholder="请输入联系电话" v-model="familySituationruleForm.phoneNumber">
										</el-input>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogfamilySituation = false">取 消</el-button>
									<el-button type="primary" @click="addfamilySituation()">确 定</el-button>
								</div>
							</el-dialog>
							<el-divider content-position="left">其他信息</el-divider>
							<div class="additionalInformation">
								<el-form :model="additionalInformation" :label-position="labelPosition"
									ref="additionalInformation" label-width="125px" class="DialogruleForm">
									<el-form-item label="兴趣爱好:" class="DialogruleFormitem">
										<el-input v-model="additionalInformation.hobby" type="textarea"
											:autosize="{ minRows: 4}">
										</el-input>
									</el-form-item>
									<el-form-item label="特长:" class="DialogruleFormitem">
										<el-input v-model="additionalInformation.specialty" type="textarea"
											:autosize="{ minRows: 4}">
										</el-input>
									</el-form-item>
									<!-- <el-form-item label="其他:" class="DialogruleFormitem">
										<el-input v-model="additionalInformation.otherInfo" type="textarea"
											:autosize="{ minRows: 4}">
										</el-input>
									</el-form-item> -->
									<el-form-item label="自我评价:" prop="evaluation" class="ruleFormitem">
										<el-input v-model="ruleForm.evaluation" type="textarea"
											:autosize="{ minRows: 4}">
										</el-input>
									</el-form-item>
								</el-form>
							</div>
							<el-divider content-position="left"><span class="mustText"> * </span>上传附件<span
									class="mustText">（必填）</span></el-divider>
							<div class="updownload_excel">
								<div>
									<span
										style="color: darkgray; font-size: 14px;">*注：请您以“第一志愿岗位名称+姓名”的方式命名附件，并以zip格式压缩包进行上传。</span><br />
									<span
										style="color: darkgray; font-size: 14px;">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp附件应包括如下材料的扫描件：</span><br />
									<span
										style="color: darkgray; font-size: 14px;">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp1.成绩单：</span><br />
									<span
										style="color: darkgray; font-size: 14px;">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp本科生需上传本科阶段成绩单，
										研究生需上传本科和研究生阶段成绩单，如最高学历为其他类型，请至少上传最高学历成绩单。</span><br />
									<span
										style="color: darkgray; font-size: 14px;">&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp2.简历中涉及的证书等相关证明材料。</span><br />
								</div>
								<el-upload class="upload_excel" :action="uploadUrl" :auto-upload="false"
									ref="excelUpload" :file-list="excelList" :with-credentials="true"
									:before-upload="beforExcelUpload" :on-change="uploadExcelChange" accept=".zip">
									<el-button class="excelButton" size="small" type="primary"
										@click="deleteFileList()">点击上传
									</el-button>
								</el-upload>
							</div>
							<el-divider content-position="left"><span class="mustText"> * </span>声明</el-divider>
							<div style="display: block;">
								<div style="display: block;">
									<div class="statement_text_area">
										<span class="statement_text">是否已经与其他单位签有工作合同或协议，或在其他单位工作且尚未办清离职手续</span>
									</div>
									<div class="statement_choose_area">
										<el-radio v-model="statmentOne" :label="1">是</el-radio>
										<el-radio v-model="statmentOne" :label="0">否</el-radio>
									</div>
								</div>
								<div style="display: block;">
									<div class="statement_text_area">
										<span class="statement_text">是否曾被其他单位惩诫、开除、辞退</span>
									</div>
									<div class="statement_choose_area">
										<el-radio v-model="statmentTwo" :label="1">是</el-radio>
										<el-radio v-model="statmentTwo" :label="0">否</el-radio>
									</div>
								</div>
								<div style="display: block;">
									<div class="statement_text_area">
										<span class="statement_text">是否有违法、违纪或其他不良行为</span>
									</div>
									<div class="statement_choose_area">
										<el-radio v-model="statmentThree" :label="1">是</el-radio>
										<el-radio v-model="statmentThree" :label="0">否</el-radio>
									</div>
								</div>
							</div>
							<div class="agree_option">
								<el-checkbox v-model="agree">
									<span class="agree_text"
										style="font-size: 14px; white-space: normal;">我承诺以上所填信息均属实准确，同意公司就上述资料的真实性进行调查核实，并对由于提供虚假信息而引发的结果承担相应的法律责任，如有虚假，责任自负。</span>
								</el-checkbox>
							</div>
						</el-form>
						<div class="avatarContainer">
							<el-image style="width: 140px; height: 200px" v-if="showImg" :src="imageLink"></el-image>
							<el-upload class="upload-demo" :action="actionUrl" :auto-upload="false" ref="avatarUpload"
								:file-list="avatarList" :with-credentials="true" :show-file-list="false"
								:before-upload="beforeUpload" :on-change="uploadChange" accept=".jpg,.png">
								<el-button class="avatarButton" size="small" type="primary">点击上传
								</el-button>
								<div class="avatarText" slot="tip">注：请上传本人近期一寸免冠正面证件照，照片大小请控制在5MB以内，支持格式：jpg、png
								</div>
							</el-upload>
						</div>
					</div>
					<el-button type="primary" round class="saveresume" @click="saveresume()" v-if="displayStatus != 1">保
						存</el-button>
					<el-button type="primary" round class="updata_resume" @click="updataResume()"
						v-if="displayStatus != 1">提 交</el-button>
				</el-main>
			</el-container>
		</el-container>
		<div class="footer">
			<div class="container">
				<p>&copy 2022 Inc. All Rights Reserved. 中水东北勘测设计研究有限责任公司 版权所有 吉ICP备2022003947号-1
					技术支持：中水东北勘测设计研究有限责任公司数字与智慧工程院
					<br />吉公网安备 22010402001082号
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		loginstatus,
		Logout,
		optResume,
		queryResume,
		uploadByOne,
		uploadByDoc,
	} from '../../api/user.js'
	import Cookies from 'js-cookie';
	export default {
		data() {
			var validateName = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('姓名不能为空'));
				} else if (value.length < 2) {
					callback(new Error('请输入正确姓名'));
				} else {
					callback();
				}
			};
			var validateMajorcourse = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('专业课程不能为空'));
				} else {
					callback();
				}
			};
			var validateAge = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('年龄不能为空'));
				} else if (value.length != 2) {
					callback(new Error('请输入正确年龄'));
				} else {
					callback();
				}
			};
			var validateHeight = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('身高不能为空'));
				} else {
					callback();
				}
			};
			var validateWight = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('体重不能为空'));
				} else {
					callback();
				}
			};
			var validatePhonenumber = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('手机号不能为空'));
				} else {
					callback();
				}
			};
			var validateDocumentnumber = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('证件号不能为空'));
				} else {
					callback();
				}
			};
			var validateNowresidence = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('现居住地不能为空'));
				} else {
					callback();
				}
			};
			var validateNativeplace = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('籍贯不能为空'));
				} else {
					callback();
				}
			};
			// var validateEmergencycontact = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error('紧急联系人不能为空'));
			// 	} else {
			// 		callback();
			// 	}
			// };
			var validateEmergencycontactphonenumber = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('紧急联系人电话不能为空'));
				} else {
					callback();
				}
			};
			var validateEnglishlevelscore = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('英语等级成绩不能为空'));
				} else {
					callback();
				}
			};
			return {
				statmentOne: null,
				statmentTwo: null,
				statmentThree: null,
				dialogcloseRelative: false,
				displayStatus: null,
				agree: false,
				uploadUrl: '',
				excelList: [],
				actionUrl: '',
				avatarList: [],
				url: '',
				imageLink: require('../../image/add.png'),
				showImg: true,
				additionalInformation: {
					hobby: '',
					// otherInfo: '',
					specialty: '',
				},
				closeRelative: [],
				familySituation: [],
				skills: [],
				certificate: [],
				projectExperience: [],
				workExperience: [],
				languageSkills: [],
				internshipExperience: [],
				papersMonographs: [],
				awards: [],
				educationalBackground: [],
				dialogfamilySituation: false,
				dialogskills: false,
				dialogcertificate: false,
				dialogprojectExperience: false,
				dialogworkExperience: false,
				dialoglanguageSkills: false,
				dialoginternshipExperience: false,
				dialogpapersMonographs: false,
				dialogawards: false,
				dialogeducationalbackground: false,
				awardTypeoptions: [{
						value: '',
						label: '请选择',
					},
					{
						value: '奖学金',
						label: '奖学金',
					},
					{
						value: '竞赛获奖',
						label: '竞赛获奖',
					},
					{
						value: '其他',
						label: '其他',
					}
				],
				skillsMasterySelect: [{
						value: '',
						label: '请选择',
					},
					{
						value: '了解',
						label: '了解',
					},
					{
						value: '一般',
						label: '一般',
					},
					{
						value: '熟练',
						label: '熟练',
					},
					{
						value: '精通',
						label: '精通',
					},
				],
				certificateTypeSelect: [{
						value: '',
						label: '请选择',
					},
					{
						value: '外语证书',
						label: '外语证书',
					},
					{
						value: '计算机证书',
						label: '计算机证书',
					},
					{
						value: '会计证书',
						label: '会计证书',
					},
					{
						value: '职称证书',
						label: '职称证书',
					},
					{
						value: '其他证书',
						label: '其他证书',
					},
					{
						value: '职业证书',
						label: '职业证书',
					},
					{
						value: '资质证书',
						label: '资质证书',
					},
				],
				masteryselect: [{
						value: '',
						label: '请选择',
					},
					{
						value: '入门',
						label: '入门',
					},
					{
						value: '日常会话',
						label: '日常会话',
					},
					{
						value: '商务会话',
						label: '商务会话',
					},
					{
						value: '无障碍沟通',
						label: '无障碍沟通',
					},
					{
						value: '母语',
						label: '母语',
					},
				],
				languageTypeselect: [{
						value: '',
						label: '请选择',
					},
					{
						value: '英语',
						label: '英语',
					},
					{
						value: '日语',
						label: '日语',
					},
					{
						value: '韩语',
						label: '韩语',
					},
					{
						value: '法语',
						label: '法语',
					},
					{
						value: '德语',
						label: '德语',
					},
					{
						value: '西班牙语',
						label: '西班牙语',
					},
					{
						value: '意大利语',
						label: '意大利语',
					},
					{
						value: '阿拉伯语',
						label: '阿拉伯语',
					},
					{
						value: '俄语',
						label: '俄语',
					},
					{
						value: '泰语',
						label: '泰语',
					},
					{
						value: '印度尼西亚语',
						label: '印度尼西亚语',
					},
					{
						value: '其他',
						label: '其他',
					},
				],
				majorrankingoptions: [{
						value: '',
						label: '请选择',
					},
					{
						value: '前5%',
						label: '前5%',
					},
					{
						value: '前10%',
						label: '前10%',
					},
					{
						value: '前20%',
						label: '前20%',
					},
					{
						value: '前30%',
						label: '前30%',
					},
					{
						value: '前50%',
						label: '前50%',
					},
					{
						value: '其他',
						label: '其他',
					},
				],
				englishleveloptions: [{
						value: '',
						label: '请选择',
					},
					{
						value: '未参加',
						label: '未参加',
					},
					{
						value: '未通过',
						label: '未通过',
					},
					{
						value: 'CET-4',
						label: 'CET-4',
					},
					{
						value: 'CET-6',
						label: 'CET-6',
					},
					{
						value: 'TEM-4',
						label: 'TEM-4',
					},
					{
						value: 'TEM-8',
						label: 'TEM-8',
					},
					{
						value: 'TOFEL',
						label: 'TOFEL',
					},
					{
						value: 'IELTS',
						label: 'IELTS',
					},
					{
						value: 'GMAT',
						label: 'GMAT',
					},
					{
						value: 'GRE',
						label: 'GRE',
					},
					{
						value: '其他',
						label: '其他',
					},
				],
				maritalstatusoptions: [{
						value: '',
						label: '请选择',
					},
					{
						value: '未婚',
						label: '未婚',
					},
					{
						value: '已婚',
						label: '已婚',
					},
					{
						value: '离异',
						label: '离异',
					},
					{
						value: '保密',
						label: '保密',
					},
				],
				nationoptions: [{
						value: '',
						label: '请选择',
					},
					{
						value: '汉族',
						label: '汉族',
					},
					{
						value: '回族',
						label: '回族',
					},
					{
						value: '蒙古族',
						label: '蒙古族',
					},
					{
						value: '藏族',
						label: '藏族',
					},
					{
						value: '苗族',
						label: '苗族',
					},
					{
						value: '维吾尔族',
						label: '维吾尔族',
					},
					{
						value: '彝族',
						label: '彝族',
					},
					{
						value: '壮族',
						label: '壮族',
					},
					{
						value: '布依族',
						label: '布依族',
					},
					{
						value: '白族',
						label: '白族',
					},
					{
						value: '朝鲜族',
						label: '朝鲜族',
					},
					{
						value: '侗族',
						label: '侗族',
					},
					{
						value: '哈尼族',
						label: '哈尼族',
					},
					{
						value: '哈萨克族',
						label: '哈萨克族',
					},
					{
						value: '土家族',
						label: '土家族',
					},
					{
						value: '满族',
						label: '满族',
					},
					{
						value: '瑶族',
						label: '瑶族',
					},
					{
						value: '达斡尔族',
						label: '达斡尔族',
					},
					{
						value: '东乡族',
						label: '东乡族',
					},
					{
						value: '高山族',
						label: '高山族',
					},
					{
						value: '景颇族',
						label: '景颇族',
					},
					{
						value: '柯尔克孜族',
						label: '柯尔克孜族',
					},
					{
						value: '拉祜族',
						label: '拉祜族',
					},
					{
						value: '纳西族',
						label: '纳西族',
					},
					{
						value: '畲族',
						label: '畲族',
					},
					{
						value: '傣族',
						label: '傣族',
					},
					{
						value: '黎族',
						label: '黎族',
					},
					{
						value: '傈僳族',
						label: '傈僳族',
					},
					{
						value: '仫佬族',
						label: '仫佬族',
					},
					{
						value: '羌族',
						label: '羌族',
					},
					{
						value: '水族',
						label: '水族',
					},
					{
						value: '土族',
						label: '土族',
					},
					{
						value: '佤族',
						label: '佤族',
					},
					{
						value: '阿昌族',
						label: '阿昌族',
					},
					{
						value: '布朗族',
						label: '布朗族',
					},
					{
						value: '毛南族',
						label: '毛南族',
					},
					{
						value: '普米族',
						label: '普米族',
					},
					{
						value: '撒拉族',
						label: '撒拉族',
					},
					{
						value: '塔吉克族',
						label: '塔吉克族',
					},
					{
						value: '锡伯族',
						label: '锡伯族',
					},
					{
						value: '仡佬族',
						label: '仡佬族',
					},
					{
						value: '保安族',
						label: '保安族',
					},
					{
						value: '德昂族',
						label: '德昂族',
					},
					{
						value: '俄罗斯族',
						label: '俄罗斯族',
					},
					{
						value: '鄂温克族',
						label: '鄂温克族',
					},
					{
						value: '京族',
						label: '京族',
					},
					{
						value: '怒族',
						label: '怒族',
					},
					{
						value: '乌孜别克族',
						label: '乌孜别克族',
					},
					{
						value: '裕固族',
						label: '裕固族',
					},
					{
						value: '独龙族',
						label: '独龙族',
					},
					{
						value: '鄂伦春族',
						label: '鄂伦春族',
					},
					{
						value: '赫哲族',
						label: '赫哲族',
					},
					{
						value: '基诺族',
						label: '基诺族',
					},
					{
						value: '珞巴族',
						label: '珞巴族',
					},
					{
						value: '门巴族',
						label: '门巴族',
					},
					{
						value: '塔塔尔族',
						label: '塔塔尔族',
					},
					{
						value: '其他',
						label: '其他',
					},
				],
				politicaloptions: [{
						value: '',
						label: '请选择',
					},
					{
						value: '中共党员',
						label: '中共党员'
					},
					{
						value: '中共预备党员',
						label: '中共预备党员'
					},
					{
						value: '共青团员',
						label: '共青团员'
					},
					{
						value: '群众',
						label: '群众'
					},
					{
						value: '无党派民主人士',
						label: '无党派民主人士'
					},
					{
						value: '民主党派成员',
						label: '民主党派成员'
					},
				],
				workinghoursoptions: [{
						value: '',
						label: '请选择',
					},
					{
						value: '在读学生',
						label: '在读学生'
					}, {
						value: '应届毕业生',
						label: '应届毕业生'
					}, {
						value: '1年',
						label: '1年'
					}, {
						value: '2年',
						label: '2年'
					}, {
						value: '3年',
						label: '3年'
					},
					{
						value: '4年',
						label: '4年'
					},
					{
						value: '5年',
						label: '5年'
					},
					{
						value: '6年',
						label: '6年'
					},
					{
						value: '7年',
						label: '7年'
					},
					{
						value: '8年',
						label: '8年'
					},
					{
						value: '9年',
						label: '9年'
					},
					{
						value: '10年及以上',
						label: '10年及以上'
					},
				],
				degreemodeoptions: [{
						value: '',
						label: '请选择',
					},
					{
						value: '全国普通高等院校全日制',
						label: '全国普通高等院校全日制'
					}, {
						value: '成人高等教育',
						label: '成人高等教育'
					}, {
						value: '统招专升本',
						label: '统招专升本'
					}, {
						value: '自学考试',
						label: '自学考试'
					}, {
						value: '其他',
						label: '其他'
					},
					{
						value: '非统招专升本',
						label: '非统招专升本'
					},
					{
						value: '海外留学生',
						label: '海外留学生'
					},
					{
						value: '全国普通高等院校非全日制',
						label: '全国普通高等院校非全日制'
					},
					{
						value: '网络教育',
						label: '网络教育'
					},
				],
				educationoptions: [{
						value: '',
						label: '请选择',
					},
					{
						value: '初中及以下',
						label: '初中及以下'
					},
					{
						value: '高中',
						label: '高中'
					},
					{
						value: '中技/中专',
						label: '中技/中专'
					},
					{
						value: '大专',
						label: '大专'
					},
					{
						value: '本科',
						label: '本科'
					},
					{
						value: '硕士研究生',
						label: '硕士研究生'
					},
					{
						value: '博士研究生',
						label: '博士研究生'
					},
				],
				educationoptions1: [{
						value: '',
						label: '请选择',
					},
					{
						value: '初中及以下',
						label: '初中及以下'
					},
					{
						value: '高中',
						label: '高中'
					},
					{
						value: '中技/中专',
						label: '中技/中专'
					},
					{
						value: '大专',
						label: '大专'
					},
					{
						value: '本科',
						label: '本科'
					},
					{
						value: '硕士研究生',
						label: '硕士研究生'
					},
					{
						value: '博士研究生',
						label: '博士研究生'
					},
				],
				documenttypeoptions: [{
						value: '',
						label: '请选择',
					},
					{
						value: '居民身份证',
						label: '居民身份证'
					},
					{
						value: '护照',
						label: '护照'
					},
					{
						value: '港澳居民来往内地通行证',
						label: '港澳居民来往内地通行证'
					},
					{
						value: '台湾居民来往大陆通行证',
						label: '台湾居民来往大陆通行证'
					},
					{
						value: '其他',
						label: '其他'
					},
				],
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				labelPosition: 'right',
				userId: '',
				showId: '',
				closeRelativeruleForm: {
					companyName: '',
					name: '',
					phoneNumber: '',
					position: '',
					relationship: '',
				},
				familySituationruleForm: {
					companyName: '',
					name: '',
					phoneNumber: '',
					position: '',
					relationship: '',
				},
				skillsruleForm: {
					name: '',
					skillsMastery: '',
				},
				certificateruleForm: {
					type: '',
					name: '',
					time: '',
					description: '',
				},
				projectExperienceruleForm: {
					projectName: '',
					projectExperiencetime: '',
					position: '',
					description: '',
				},
				workExperienceruleForm: {
					workExperiencename: '',
					workExperiencetime: '',
					workExperiencecontent: '',
					position: '',
				},
				languageSkillsruleForm: {
					languageType: '',
					mastery: '',
				},
				internshipExperienceruleForm: {
					internshipExperiencename: '',
					position: '',
					internshipExperiencetime: '',
					internshipExperiencecontent: '',
				},
				papersMonographsruleForm: {
					papersMonographsname: '',
					papersMonographstime: '',
					papersMonographsperiodical: '',
					papersMonographsannualPeriod: '',
					papersMonographsauthorOrder: '',
				},
				awardsruleForm: {
					awardType: '',
					awardsname: '',
					awardstime: '',
					description: '',
				},
				educationalbackgroundruleForm: {
					schoolname: '',
					studytime: '',
					majorname: '',
					dialogeducation: '',
					majorcourses: '',
					majorranking: '',
				},
				ruleForm: {
					email: '',
					resumeEditStatus: null,
					name: '',
					sex: '',
					birthdate: '',
					age: null,
					height: null,
					phonenumber: '',
					documenttype: '',
					documentnumber: '',
					education: '',
					degreemode: '',
					graduatedate: '',
					// studyabroad: null,
					// freshgraduates: null,
					// workinghours: '',
					// workingdate: '',
					nowresidence: '',
					political: '',
					nation: '',
					nativeplace: '',
					maritalstatus: '',
					// childstatus: '',
					emergencycontact: '',
					emergencycontactphonenumber: '',
					evaluation: '',
					englishlevel: '',
					englishlevelscore: '',
					resumestate: null,
					weight: '',
				},
				rules: {
					name: [{
						required: true,
						validator: validateName,
						trigger: 'blur',
					}, ],
					sex: [{
						required: true,
						message: '请选择性别',
						trigger: 'change',
					}, ],
					birthdate: [{
						required: true,
						message: '请选择出生日期',
						trigger: 'change',
					}, ],
					age: [{
						required: true,
						validator: validateAge,
						trigger: 'blur',
					}, ],
					height: [{
						required: true,
						validator: validateHeight,
						trigger: 'blur',
					}, ],
					weight: [{
						required: true,
						validator: validateWight,
						trigger: 'blur',
					}, ],
					email: [{
							required: true,
							message: '请输入邮箱地址',
							trigger: 'blur',
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: ['blur', 'change'],
						},
					],
					phonenumber: [{
						required: true,
						validator: validatePhonenumber,
						trigger: 'blur',
					}, ],
					documenttype: [{
						required: true,
						message: '请选择证件类型',
						trigger: 'change',
					}, ],
					documentnumber: [{
						required: true,
						validator: validateDocumentnumber,
						trigger: 'blur',
					}, ],
					education: [{
						required: true,
						message: '请选择最高学历',
						trigger: 'change',
					}, ],
					degreemode: [{
						required: true,
						message: '请选择学习方式',
						trigger: 'change',
					}, ],
					graduatedate: [{
						required: true,
						message: '请选择毕业日期',
						trigger: 'change',
					}, ],
					// studyabroad: [{
					// 	required: true,
					// 	message: '请选择是否留学',
					// 	trigger: 'change',
					// }, ],
					// freshgraduates: [{
					// 	required: true,
					// 	message: '请选择是否应届',
					// 	trigger: 'change',
					// }, ],
					// workinghours: [{
					// 	required: false,
					// 	message: '请选择工作时长',
					// 	trigger: 'change',
					// }, ],
					// workingdate: [{
					// 	required: false,
					// 	message: '请选择参加工作日期',
					// 	trigger: 'change',
					// }, ],
					nowresidence: [{
						required: true,
						validator: validateNowresidence,
						trigger: 'blur',
					}, ],
					political: [{
						required: true,
						message: '请选择政治面貌',
						trigger: 'change',
					}, ],
					nation: [{
						required: true,
						message: '请选择民族',
						trigger: 'change',
					}, ],
					nativeplace: [{
						required: true,
						validator: validateNativeplace,
						trigger: 'change',
					}, ],
					maritalstatus: [{
						required: true,
						message: '请选择婚姻状态',
						trigger: 'change',
					}, ],
					// childstatus: [{
					// 	required: true,
					// 	message: '请选择子女状态',
					// 	trigger: 'change',
					// }, ],
					// emergencycontact: [{
					// 	required: true,
					// 	validator: validateEmergencycontact,
					// 	trigger: 'blur',
					// }, ],
					emergencycontactphonenumber: [{
						required: true,
						validator: validateEmergencycontactphonenumber,
						trigger: 'blur',
					}, ],
					englishlevel: [{
						required: true,
						message: '请选择英语等级',
						trigger: 'change',
					}, ],
					englishlevelscore: [{
						required: true,
						validator: validateEnglishlevelscore,
						trigger: 'blur',
					}, ],
					resumestate: [{
						required: true,
						message: '请选择简历类型',
						trigger: 'change',
					}, ],
				},
			}
		},
		mounted() {
			loginstatus().then((res) => {
				if (res.code == 200) {
					let str = res.data;
					this.showId = str.substring(0, 3) + '****' + str.substring(7, 11);
					this.userId = res.data;
					queryResume({
						userID: this.userId,
					}).then((res) => {
						if (res.code == 200) {
							if (res.data.docLink != null) {
								var arr = {
									url: res.data.docLink,
									name: '附件.zip',
								}
								this.excelList.push(arr)
							}
							if (res.data.resumeEditStatus == 1) {
								this.displayStatus = 1
								this.agree = true
							} else {
								this.agree = false
							}
							this.resumeEditStatus = res.data.resumeEditStatus
							if (res.data.imageLink != null) {
								console.log('123')
								this.imageLink = res.data.imageLink;
								console.log(this.imageLink)
							}
							if (res.data.birthday == null) {
								this.ruleForm.birthdate = ''
							} else {
								this.ruleForm.birthdate = timestampToTime(res.data.birthday);
							}
							this.ruleForm.name = res.data.name;
							if (res.data.gender == null) {
								this.ruleForm.sex = '';
							} else {
								this.ruleForm.sex = res.data.gender;
							}
							this.ruleForm.weight = res.data.weight;
							if (res.data.age == 0) {
								this.ruleForm.age = null
							} else {
								this.ruleForm.age = res.data.age;
							}
							if (res.data.age == 0) {
								this.ruleForm.height = null
							} else {
								this.ruleForm.height = res.data.height
							}
							this.ruleForm.phonenumber = res.data.phoneNumber;
							if (res.data.documentsType == null) {
								this.ruleForm.documenttype = ''
							} else {
								this.ruleForm.documenttype = res.data.documentsType;
							}
							this.ruleForm.documentnumber = res.data.documentsNumber;
							if (res.data.degree == null) {
								this.ruleForm.education = ''
							} else {
								this.ruleForm.education = res.data.degree;
							}
							if (res.data.degreeMode == null) {
								this.ruleForm.degreemode = ''
							} else {
								this.ruleForm.degreemode = res.data.degreeMode;
							}
							if (res.data.birthday == null) {
								this.ruleForm.graduatedate = ''
							} else {
								this.ruleForm.graduatedate = timestampToTime(res.data.graduationTime);
							}
							// this.ruleForm.studyabroad = res.data.studyAbroad;
							// this.ruleForm.freshgraduates = res.data.freshPast;

							// this.ruleForm.workinghours = res.data.workDuration;
							// this.ruleForm.workingdate = timestampToTime(res.data.workStartTime);
							this.ruleForm.nowresidence = res.data.currentResidence;
							if (res.data.politicalLandscape == null) {
								this.ruleForm.political = ''
							} else {
								this.ruleForm.political = res.data.politicalLandscape;
							}
							if (res.data.ethnicGroup == null) {
								this.ruleForm.nation = ''
							} else {
								this.ruleForm.nation = res.data.ethnicGroup;
							}
							this.ruleForm.nativeplace = res.data.origin;
							if (res.data.maritalStatus == null) {
								this.ruleForm.maritalstatus = ''
							} else {
								this.ruleForm.maritalstatus = res.data.maritalStatus;
							}
							// if (res.data.childrenStatus == null) {
							// 	this.ruleForm.childstatus = ''
							// } else {
							// 	this.ruleForm.childstatus = res.data.childrenStatus;
							// }

							// this.ruleForm.emergencycontact = res.data.emergencyContacts;

							this.ruleForm.emergencycontactphonenumber = res.data
								.emergencyContactsPhoneNumber;
							this.ruleForm.evaluation = res.data.selfEvaluation;
							if (res.data.levelOfEnglish == null) {
								this.ruleForm.englishlevel = ''
							} else {
								this.ruleForm.englishlevel = res.data.levelOfEnglish;
							}
							this.ruleForm.englishlevelscore = res.data.scoresOfEnglish;
							this.ruleForm.resumestate = res.data.resume_type;
							this.ruleForm.email = res.data.mail;
							this.educationalBackground = res.data.educationalBackground;
							this.awards = res.data.awards;
							this.papersMonographs = res.data.papersMonographs;
							this.internshipExperience = res.data.internshipExperience;
							this.languageSkills = res.data.languageSkills;
							this.workExperience = res.data.workExperience;
							this.projectExperience = res.data.projectExperience;
							this.certificate = res.data.certificate;
							this.skills = res.data.skills;
							this.familySituation = res.data.familySituation;
							if (res.data.waterSystemRelativesInfo.length == 0 || res.data.waterSystemRelativesInfo == null) {
								let closeRelativeArr = {
									companyName: '',
									name: '',
									phoneNumber: '',
									position: '',
									relationship: '',
								}
								this.closeRelative.push(closeRelativeArr)
							} else {
								this.closeRelative = res.data.waterSystemRelativesInfo;
							}
							if (res.data.otherWorkContractsStatus == -1) {
								this.statmentOne = null
							} else {
								this.statmentOne = res.data.otherWorkContractsStatus
							}
							if (res.data.workPunishmentsStatus == -1) {
								this.statmentTwo = null
							} else {
								this.statmentTwo = res.data.workPunishmentsStatus
							}
							if (res.data.illegalRecordStatus == -1) {
								this.statmentThree = null
							} else {
								this.statmentThree = res.data.illegalRecordStatus
							}
							this.additionalInformation = res.data.additionalInformation;
						} else if (res.code == 20066) {
							this.$message({
								message: '您尚未创建简历！',
								type: 'error'
							});
						}
					});
				} else if (res.code == 400) {
					this.$message({
						message: '未检测到登录信息！',
						type: 'error'
					});
					this.$router.push('/')
				}
			});
		},
		// computed: {
		// 	getImageUrl() {
		// 		return require(this.url);
		// 	}
		// },
		methods: {
			dialogRelative(index) {
				console.log(index)
				console.log(this.closeRelative[index])
				this.closeRelative.splice(index, 1)
			},
			addRelatives() {
				let arr = {
					companyName: '',
					name: '',
					phoneNumber: '',
					position: '',
					relationship: '',
				}
				this.closeRelative.push(arr)
			},
			deleteFileList() {
				if (this.excelList != 0) {
					this.excelList = undefined
					this.excelList = new Array();
				}
			},
			uploadExcelChange() {
				if (this.ruleForm.name != '') {
					optResume({
						name: this.ruleForm.name,
						birthday: this.ruleForm.birthdate,
						gender: this.ruleForm.sex,
						age: this.ruleForm.age,
						height: this.ruleForm.height,
						weight: this.ruleForm.weight,
						phoneNumber: this.ruleForm.phonenumber,
						documentsType: this.ruleForm.documenttype,
						documentsNumber: this.ruleForm.documentnumber,
						degree: this.ruleForm.education,
						degreeMode: this.ruleForm.degreemode,
						graduationTime: this.ruleForm.graduatedate,
						// studyAbroad: this.ruleForm.studyabroad,
						// freshPast: this.ruleForm.freshgraduates,
						// workDuration: this.ruleForm.workinghours,
						// workStartTime: this.ruleForm.workingdate,
						currentResidence: this.ruleForm.nowresidence,
						politicalLandscape: this.ruleForm.political,
						ethnicGroup: this.ruleForm.nation,
						origin: this.ruleForm.nativeplace,
						maritalStatus: this.ruleForm.maritalstatus,
						// childrenStatus: this.ruleForm.childstatus,
						// emergencyContacts: this.ruleForm.emergencycontact,
						emergencyContactsPhoneNumber: this.ruleForm.emergencycontactphonenumber,
						selfEvaluation: this.ruleForm.evaluation,
						levelOfEnglish: this.ruleForm.englishlevel,
						scoresOfEnglish: this.ruleForm.englishlevelscore,
						userID: this.userId,
						resume_type: this.ruleForm.resumestate,
						mail: this.ruleForm.email,
						educationalBackground: this.educationalBackground,
						awards: this.awards,
						papersMonographs: this.papersMonographs,
						internshipExperience: this.internshipExperience,
						languageSkills: this.languageSkills,
						workExperience: this.workExperience,
						projectExperience: this.projectExperience,
						certificate: this.certificate,
						skills: this.skills,
						waterSystemRelativesInfo: this.closeRelative,
						otherWorkContractsStatus: this.statmentOne,
						workPunishmentsStatus: this.statmentTwo,
						illegalRecordStatus: this.statmentThree,
						familySituation: this.familySituation,
						additionalInformation: this.additionalInformation,
					}).then((res2) => {
						var file = this.$refs.excelUpload.uploadFiles
						let formData = new window.FormData();
						formData.append('file', file[0].raw);
						// this.$refs.avatarUpload.submit();
						uploadByDoc(file[0].raw).then((res) => {
							queryResume({
								userID: this.userId,
							}).then((res1) => {
								if (res1.data.docLink == null) {
									this.$message({
										message: '附件上传失败！',
										type: 'error'
									});
								} else {
									this.$message({
										message: '附件上传成功！',
										type: 'success'
									});
									var arr = {
										url: res1.data.docLink,
										name: '附件.zip',
									}
									this.excelList.push(arr)
								}
							})
						})
					})
				} else {
					this.$message({
						message: '请先填写您的姓名信息！',
						type: 'error'
					});
					this.excelList = undefined
					this.excelList = new Array();
					queryResume({
						userID: this.userId,
					}).then((res) => {
						if (res.code == 200) {
							var arr = {
								url: res.data.docLink,
								name: '附件.zip',
							}
							this.excelList.push(arr)
						}
					})
				}
			},
			beforExcelUpload(file) {
				const isLt100M = file.size / 1024 / 1024 < 100
				if (!isLt100M) {
					this.$message({
						message: '附件大小不能超过 100MB！',
						type: 'error'
					});
					this.$refs['avatarUpload'].clearFiles();
				}
				return isLt100M;
			},
			beforeUpload(file) {
				const isLt20M = file.size / 1024 / 1024 < 5;
				if (!isLt20M) {
					this.$message.error('上传照片大小不能超过 5MB!');
					this.$refs['avatarUpload'].clearFiles();
				}
				return isLt20M;
			},
			uploadChange() {
				var that = this
				var file = this.$refs.avatarUpload.uploadFiles
				let formData = new window.FormData();
				formData.append('file', file[0].raw);
				// this.$refs.avatarUpload.submit();
				uploadByOne(file[0].raw).then((res) => {
					this.$message({
						message: '照片上传成功！',
						type: 'success'
					});
					this.avatarList = undefined
					this.avatarList = new Array
					queryResume({
						userID: this.userId,
					}).then((res1) => {
						this.showImg = false
						this.$nextTick(() => {
							this.showImg = true
							if (res1.data.imageLink != null) {
								this.imageLink = res1.data.imageLink;
							}
							that.$forceUpdate();
						})

					})
				})
			},
			updataResume() {
				if (this.statmentOne != null && this.statmentTwo != null && this.statmentThree != null) {
					if (this.agree == true) {
						// if (this.excelList.length == 0) {
						// 	this.$message({
						// 		message: '请上传附件！',
						// 		type: 'error'
						// 	});
						// } else {
						if (this.educationalBackground.length == 0) {
							this.$message({
								message: '教育背景不能为空！',
								type: 'error'
							});
						} else {
							if (this.familySituation.length == 0) {
								this.$message({
									message: '家庭情况不能为空！',
									type: 'error'
								});
							} else {
								if (this.ruleForm.name == '' || this.ruleForm.sex == '' || this.ruleForm.birthdate ==
									'' ||
									this
									.ruleForm.age == null || this.ruleForm.height == null || this.ruleForm.weight ==
									'' || this
									.ruleForm.email == '' || this.ruleForm.phonenumber == '' || this.ruleForm
									.documenttype ==
									'' ||
									this.ruleForm.documenttype == '' || this.ruleForm.documentnumber == '' || this
									.ruleForm
									.education == '' ||
									this.ruleForm.degreemode == '' || this.ruleForm.graduatedate == '' ||
									this.ruleForm.nowresidence == '' || this
									.ruleForm
									.nation ==
									'' ||
									this.ruleForm.nativeplace == '' || this.ruleForm.maritalstatus == '' ||
									this.ruleForm.emergencycontactphonenumber == '' || this.ruleForm.englishlevel ==
									'' || this
									.ruleForm.englishlevelscore == '' ||
									this.ruleForm.resumestate == null) {
									this.$message({
										message: '有必填项为空！',
										type: 'error'
									});
								} else {
									this.$confirm('简历提交后无法修改，请确认填写内容完整准确。', '注意', {
										confirmButtonText: '确认提交',
										cancelButtonText: '取消',
									}).then(() => {
										optResume({
											resumeEditStatus: 1,
											name: this.ruleForm.name,
											birthday: this.ruleForm.birthdate,
											gender: this.ruleForm.sex,
											age: this.ruleForm.age,
											height: this.ruleForm.height,
											weight: this.ruleForm.weight,
											phoneNumber: this.ruleForm.phonenumber,
											documentsType: this.ruleForm.documenttype,
											documentsNumber: this.ruleForm.documentnumber,
											degree: this.ruleForm.education,
											degreeMode: this.ruleForm.degreemode,
											graduationTime: this.ruleForm.graduatedate,
											// studyAbroad: this.ruleForm.studyabroad,
											// freshPast: this.ruleForm.freshgraduates,
											// workDuration: this.ruleForm.workinghours,
											// workStartTime: this.ruleForm.workingdate,
											currentResidence: this.ruleForm.nowresidence,
											politicalLandscape: this.ruleForm.political,
											ethnicGroup: this.ruleForm.nation,
											origin: this.ruleForm.nativeplace,
											maritalStatus: this.ruleForm.maritalstatus,
											// childrenStatus: this.ruleForm.childstatus,
											// emergencyContacts: this.ruleForm.emergencycontact,
											emergencyContactsPhoneNumber: this.ruleForm
												.emergencycontactphonenumber,
											selfEvaluation: this.ruleForm.evaluation,
											levelOfEnglish: this.ruleForm.englishlevel,
											scoresOfEnglish: this.ruleForm.englishlevelscore,
											userID: this.userId,
											resume_type: this.ruleForm.resumestate,
											mail: this.ruleForm.email,
											educationalBackground: this.educationalBackground,
											awards: this.awards,
											papersMonographs: this.papersMonographs,
											internshipExperience: this.internshipExperience,
											languageSkills: this.languageSkills,
											workExperience: this.workExperience,
											projectExperience: this.projectExperience,
											certificate: this.certificate,
											skills: this.skills,
											waterSystemRelativesInfo: this.closeRelative,
											otherWorkContractsStatus: this.statmentOne,
											workPunishmentsStatus: this.statmentTwo,
											illegalRecordStatus: this.statmentThree,
											familySituation: this.familySituation,
											additionalInformation: this.additionalInformation,
										}).then((res) => {
											if (res.code == 200) {
												this.$message({
													message: '简历提交成功！',
													type: 'success'
												});
												queryResume({
													userID: this.userId,
												}).then((res) => {
													if (res.data.resumeEditStatus == 1) {
														this.displayStatus = 1
													}
												})
											} else {
												this.$message({
													message: '简历提交失败！',
													type: 'error'
												});
											}
										})
									}).catch(() => {
										this.$message({
											type: 'info',
											message: '已取消提交'
										});
									});
								}
							}
							// }
						}
					} else {
						this.$message({
							message: '请勾选本人承诺，完成简历提交！',
							type: 'error'
						});
					}
				} else {
					this.$message({
						message: '请勾选声明内容，完成简历提交！',
						type: 'error'
					});
				}
			},
			saveresume() {
				optResume({
					resumeEditStatus: this.resumeEditStatus,
					name: this.ruleForm.name,
					birthday: this.ruleForm.birthdate,
					gender: this.ruleForm.sex,
					age: this.ruleForm.age,
					height: this.ruleForm.height,
					weight: this.ruleForm.weight,
					phoneNumber: this.ruleForm.phonenumber,
					documentsType: this.ruleForm.documenttype,
					documentsNumber: this.ruleForm.documentnumber,
					degree: this.ruleForm.education,
					degreeMode: this.ruleForm.degreemode,
					graduationTime: this.ruleForm.graduatedate,
					// studyAbroad: this.ruleForm.studyabroad,
					// freshPast: this.ruleForm.freshgraduates,
					// workDuration: this.ruleForm.workinghours,
					// workStartTime: this.ruleForm.workingdate,
					currentResidence: this.ruleForm.nowresidence,
					politicalLandscape: this.ruleForm.political,
					ethnicGroup: this.ruleForm.nation,
					origin: this.ruleForm.nativeplace,
					maritalStatus: this.ruleForm.maritalstatus,
					// childrenStatus: this.ruleForm.childstatus,
					// emergencyContacts: this.ruleForm.emergencycontact,
					emergencyContactsPhoneNumber: this.ruleForm
						.emergencycontactphonenumber,
					selfEvaluation: this.ruleForm.evaluation,
					levelOfEnglish: this.ruleForm.englishlevel,
					scoresOfEnglish: this.ruleForm.englishlevelscore,
					userID: this.userId,
					resume_type: this.ruleForm.resumestate,
					mail: this.ruleForm.email,
					educationalBackground: this.educationalBackground,
					awards: this.awards,
					papersMonographs: this.papersMonographs,
					internshipExperience: this.internshipExperience,
					languageSkills: this.languageSkills,
					workExperience: this.workExperience,
					projectExperience: this.projectExperience,
					certificate: this.certificate,
					skills: this.skills,
					waterSystemRelativesInfo: this.closeRelative,
					otherWorkContractsStatus: this.statmentOne,
					workPunishmentsStatus: this.statmentTwo,
					illegalRecordStatus: this.statmentThree,
					familySituation: this.familySituation,
					additionalInformation: this.additionalInformation,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: '简历保存成功！',
							type: 'success'
						});
					} else {
						this.$message({
							message: '简历保存失败！',
							type: 'error'
						});
					}
				})
			},
			dialogDelete(name, index) {
				this[name].splice(index, 1)
			},
			addfamilySituation() {
				var arr = {
					companyName: this.familySituationruleForm.companyName,
					name: this.familySituationruleForm.name,
					phoneNumber: this.familySituationruleForm.phoneNumber,
					position: this.familySituationruleForm.position,
					relationship: this.familySituationruleForm.relationship,
				}
				this.familySituation.push(arr);
				this.dialogfamilySituation = false;
				this.familySituationruleForm.companyName = '';
				this.familySituationruleForm.name = '';
				this.familySituationruleForm.phoneNumber = '';
				this.familySituationruleForm.position = '';
				this.familySituationruleForm.relationship = '';
			},
			addcloseRelative() {
				var arr = {
					companyName: this.closeRelativeruleForm.companyName,
					name: this.closeRelativeruleForm.name,
					phoneNumber: this.closeRelativeruleForm.phoneNumber,
					position: this.closeRelativeruleForm.position,
					relationship: this.closeRelativeruleForm.relationship,
				}
				this.closeRelative.push(arr);
				this.dialogcloseRelative = false;
				this.closeRelativeruleForm.companyName = '';
				this.closeRelativeruleForm.name = '';
				this.closeRelativeruleForm.phoneNumber = '';
				this.closeRelativeruleForm.position = '';
				this.closeRelativeruleForm.relationship = '';
			},
			addskills() {
				var arr = {
					mastery: this.skillsruleForm.skillsMastery,
					name: this.skillsruleForm.name,
				}
				this.skills.push(arr);
				this.dialogskills = false;
				this.skillsruleForm.skillsMastery = '';
				this.skillsruleForm.name = '';
			},
			addcertificate() {
				var arr = {
					description: this.certificateruleForm.description,
					name: this.certificateruleForm.name,
					time: this.certificateruleForm.time,
					type: this.certificateruleForm.type,
				}
				this.certificate.push(arr);
				this.dialogcertificate = false;
				this.certificateruleForm.description = '';
				this.certificateruleForm.name = '';
				this.certificateruleForm.time = '';
				this.certificateruleForm.type = '';
			},
			addprojectExperience() {
				var arr = {
					projectName: this.projectExperienceruleForm.projectName,
					position: this.projectExperienceruleForm.position,
					endTime: this.projectExperienceruleForm.projectExperiencetime[1],
					startTime: this.projectExperienceruleForm.projectExperiencetime[0],
					description: this.projectExperienceruleForm.description,
				}
				this.projectExperience.push(arr);
				this.dialogprojectExperience = false;
				this.projectExperienceruleForm.projectName = '';
				this.projectExperienceruleForm.position = '';
				this.projectExperienceruleForm.projectExperiencetime = '';
				this.projectExperienceruleForm.description = '';
			},
			addworkExperience() {
				var arr = {
					companyName: this.workExperienceruleForm.workExperiencename,
					content: this.workExperienceruleForm.workExperiencecontent,
					endTime: this.workExperienceruleForm.workExperiencetime[1],
					startTime: this.workExperienceruleForm.workExperiencetime[0],
					position: this.workExperienceruleForm.position,
				}
				this.workExperience.push(arr);
				this.dialogworkExperience = false;
				this.workExperienceruleForm.workExperiencename = '';
				this.workExperienceruleForm.workExperiencecontent = '';
				this.workExperienceruleForm.workExperiencetime = '';
				this.workExperienceruleForm.position = '';
			},
			addlanguageSkill() {
				var arr = {
					languageType: this.languageSkillsruleForm.languageType,
					mastery: this.languageSkillsruleForm.mastery,
				}
				this.languageSkills.push(arr);
				this.dialoglanguageSkills = false;
				this.languageSkillsruleForm.languageType = '';
				this.languageSkillsruleForm.mastery = '';
			},
			addinternshipExperience() {
				var arr = {
					companyName: this.internshipExperienceruleForm.internshipExperiencename,
					content: this.internshipExperienceruleForm.internshipExperiencecontent,
					endTime: this.internshipExperienceruleForm.internshipExperiencetime[1],
					startTime: this.internshipExperienceruleForm.internshipExperiencetime[0],
					position: this.internshipExperienceruleForm.position,
				}
				this.internshipExperience.push(arr);
				this.dialoginternshipExperience = false;
				this.internshipExperienceruleForm.internshipExperiencename = '';
				this.internshipExperienceruleForm.internshipExperiencecontent = '';
				this.internshipExperienceruleForm.internshipExperiencetime = '';
				this.internshipExperienceruleForm.position = '';
			},
			addpapersMonographs() {
				var arr = {
					name: this.papersMonographsruleForm.papersMonographsname,
					time: this.papersMonographsruleForm.papersMonographstime,
					annualPeriod: this.papersMonographsruleForm.papersMonographsannualPeriod,
					authorOrder: this.papersMonographsruleForm.papersMonographsauthorOrder,
					periodical: this.papersMonographsruleForm.papersMonographsperiodical,
				}
				this.papersMonographs.push(arr);
				this.dialogpapersMonographs = false;
				this.papersMonographsruleForm.papersMonographsname = '';
				this.papersMonographsruleForm.papersMonographstime = '';
				this.papersMonographsruleForm.papersMonographsannualPeriod = '';
				this.papersMonographsruleForm.papersMonographsauthorOrder = '';
				this.papersMonographsruleForm.papersMonographsperiodical = '';
			},
			addawards() {
				var arr = {
					awardType: this.awardsruleForm.awardType,
					name: this.awardsruleForm.awardsname,
					time: this.awardsruleForm.awardstime.toString(),
					description: this.awardsruleForm.description,
				}
				this.awards.push(arr);
				this.dialogawards = false;
				this.awardsruleForm.awardType = '';
				this.awardsruleForm.awardsname = '';
				this.awardsruleForm.awardstime = '';
				this.awardsruleForm.description = '';
			},
			addeducationalbackground() {
				var arr = {
					degree: this.educationalbackgroundruleForm.dialogeducation,
					endTime: this.educationalbackgroundruleForm.studytime[1],
					majorName: this.educationalbackgroundruleForm.majorname,
					name: this.educationalbackgroundruleForm.schoolname,
					professionalCourses: this.educationalbackgroundruleForm.majorcourses,
					professionalRanking: this.educationalbackgroundruleForm.majorranking,
					startTime: this.educationalbackgroundruleForm.studytime[0],
				}
				this.educationalBackground.push(arr);
				this.dialogeducationalbackground = false;
				this.educationalbackgroundruleForm.dialogeducation = '';
				this.educationalbackgroundruleForm.studytime = '';
				this.educationalbackgroundruleForm.majorname = '';
				this.educationalbackgroundruleForm.schoolname = '';
				this.educationalbackgroundruleForm.majorcourses = '';
				this.educationalbackgroundruleForm.majorranking = '';
			},
			exit() {
				Logout().then((res) => {
					this.$router.push('/')
				})
			},
			gotohome() {
				this.$router.push('/')
			},
			// gotoresume() {
			// 	this.$router.push('/personal/resume')
			// },
			gotocollect() {
				this.$router.push('/personal/collect')
			},
			gotosubmit() {
				this.$router.push('/personal/submit')
			},
		},
	}

	function timestampToTime(timestamp) {
		timestamp = timestamp ? timestamp : null;
		let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		let Y = date.getFullYear() + '-';
		let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
		return Y + M + D;
	}
</script>

<style lang="scss" scoped>
	@import url(../../assets/css/personal.css);

	.resumeContainer {
		display: flex;
	}

	.relative_form_item {
		padding: 30px 40px;
		display: flex;
		flex-wrap: wrap;

		.el-form-item {
			width: 48%;
		}

		::v-deep .el-date-editor {
			width: 100%;
		}

		.el-divider__text {
			background-color: #e5eef7;
		}
	}

	.relatives_form {
		display: flex;
	}

	.ruleForm {
		width: 70%;
		border-radius: 2px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		padding: 30px 40px;
		display: flex;
		flex-wrap: wrap;

		.el-form-item {
			width: 48%;
		}

		::v-deep .el-date-editor {
			width: 100%;
		}

		.el-divider__text {
			background-color: #e5eef7;
		}
	}

	.height {
		width: calc(100% - 25px);
	}

	.textnote {
		font-size: 12px;
		line-height: 1.3;
	}

	.DialogruleForm {
		.el-form-item {
			width: 100%;
		}
	}

	.Schoolnamecss {
		width: calc(100% - 204px);
	}

	.Increase {
		margin-left: 10%;
	}

	.Descriptions {
		margin-top: 35px;
		width: 100%;
		position: relative;
	}

	.del-desc {
		display: none;
		position: relative;
	}

	.dialogDelete {
		position: absolute;
		right: 0;
		top: -30px;
	}

	.additionalInformation {
		width: 100%;
	}

	.saveresume {
		margin-top: 35px;
		margin-left: 30%;
		width: 150px;
		font-size: 16px;
	}

	.updata_resume {
		margin-top: 35px;
		margin-left: 30px !important;
		width: 150px;
		font-size: 16px;
	}

	.avatarContainer {
		height: 400px;
		width: 140px;
		margin-left: 8%;
		margin-top: 35px;
	}

	.avatarButton {
		font-size: 12px;
		width: 100px;
		margin-left: 20px;
		margin-top: 10px;
	}

	.avatarText {
		font-size: 10px;
	}

	.updownload_excel {
		margin-left: 10%;
	}

	.download_excel {
		margin-top: 25px;
		margin-left: 55px;
	}

	.upload_excel {
		margin-top: 35px;
		margin-left: 60px;
	}

	.mustText {
		color: red;
	}

	.agree_option {
		margin-top: 35px;
		margin-left: 10%;
		width: 80%;
	}

	::v-deep .el-checkbox__input {
		vertical-align: top !important;
	}

	.agree_text {
		color: #000;
	}

	.educational_experience {
		width: 100%;
		display: block;
	}

	.explanatory {
		margin-left: 10%;
	}

	.closeRelative_text_area {
		margin-left: 8%;
		margin-top: 5px;
		width: 100%;
	}

	.closeRelative_choose_area {
		margin-left: 10%;
		width: 100%;
		margin-top: 5px;
	}

	.statement_text_area {
		margin-left: 20%;
		margin-top: 10px;
		width: 100%;
	}

	.statement_choose_area {
		margin-left: 25%;
		margin-top: 10px;
		width: 100%;
	}
</style>
